import SimpleSelect from '@Components/Common/SimpleSelect';
import { useTranslation } from 'react-i18next';

const ItemsPerPage = ({ label, pageSize, onChange }) => {
    const { t } = useTranslation('controls');

    return (
        <SimpleSelect
            options={[
                {
                    value: 50,
                    label: `50 ${label} ${t('per page')}`,
                },
                {
                    value: 100,
                    label: `100 ${label} ${t('per page')}`,
                },
                {
                    value: 250,
                    label: `250 ${label} ${t('per page')}`,
                },
                {
                    value: 500,
                    label: `500 ${label} ${t('per page')}`,
                },
            ]}
            value={pageSize}
            onChange={e => onChange(e.target.value)}
        />
    );
};

export default ItemsPerPage;
